import { handleActions } from 'redux-actions';

import { sanitize } from 'data/actions';
import {
  appSetOnlineStatus,
  appSetServiceWorkerUpdateIsAvailable,
  setAwaitingToAutoRefresh,
  setAppProps,
} from 'data/app/actions';
import { importDataSuccess, importDataFailure } from 'data/import/importActions';
import { createJobStatusSuccess, deleteJobStatus } from 'data/jobStatus/actions';

import { mkAppStore } from './types';

const reducer = handleActions({

  [appSetOnlineStatus]: (state, { payload: value }) => state.merge({ isOnline: value }),
  [appSetServiceWorkerUpdateIsAvailable]: (state, { payload: value }) => state.merge({ serviceWorkerUpdateIsAvailable: value }),

  [sanitize]: (state) => state.merge({ isSanitized: true }),

  [setAwaitingToAutoRefresh]: (state, { payload: value }) => state.set('awaitingToAutoRefresh', value),

  [createJobStatusSuccess]: (state) => state.merge({fetchInProgress: true}),
  [deleteJobStatus]: (state) => state.merge({fetchInProgress: false}),

  [setAppProps]: (state, { payload }) => state.mergeDeep(payload),

  [importDataSuccess]:
    (state, { payload }) => state.mergeDeep({ csvImportCompleteByClientId: state.csvImportCompleteByClientId.set(payload.clientId, payload) }),

  [importDataFailure]:
    (state, { payload }) => state.mergeDeep({ csvImportErrorByClientId: state.csvImportErrorByClientId.set(payload.clientId, payload) }),

}, mkAppStore());

export const REDUCER_KEY = 'appStore';
export default reducer;
